module.exports = __webpack_public_path__ + "img/12351.300f97cb.png";